import { render, staticRenderFns } from "./_taskDetails.vue?vue&type=template&id=ff0f81c8&scoped=true"
import script from "./_taskDetails.vue?vue&type=script&lang=js"
export * from "./_taskDetails.vue?vue&type=script&lang=js"
import style0 from "./_taskDetails.vue?vue&type=style&index=0&id=ff0f81c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f81c8",
  null
  
)

export default component.exports